import { render, staticRenderFns } from "./commonPayeeSelect.vue?vue&type=template&id=a38d4152&scoped=true"
import script from "./commonPayeeSelect.vue?vue&type=script&lang=js"
export * from "./commonPayeeSelect.vue?vue&type=script&lang=js"
import style0 from "./commonPayeeSelect.vue?vue&type=style&index=0&id=a38d4152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d4152",
  null
  
)

export default component.exports